module.exports = __webpack_public_path__ + "img/company.2c824c21.jpg";